// src/components/OutsourceMedicalBilling.js
import React, { useState } from 'react';
import './OutsourceMedicalBilling.css';

const OutsourceMedicalBilling = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    practiceName: '',
    email: '',
    phone: '',
    specialty: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const specialties = [
    'Cardiology', 'Neurology', 'Pediatrics', 'Dermatology', 'Orthopedics',
    'Ophthalmology', 'Mental Health', 'Nephrology', 'Podiatry', 'Allergy',
    'Rehab', 'Neurosurgery', 'Geriatrics', 'Other'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://formspree.io/f/xrejwqgl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Thank you! We will contact you shortly about outsourcing your medical billing.' });
        setFormData({ fullName: '', practiceName: '', email: '', phone: '', specialty: '', message: '' });
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again or call us directly.' });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
    }
  };

  const benefits = [
    '99% ITPR (First Time Claims Passing Rate)',
    'Lowest Aging in 60+ and 90+ per MGMA Standards',
    '100% reimbursement on all claims'
  ];

  const features = [
    'Electronic set-up for claims and EFT set-up for payments to ensure clients receive payments very quickly',
    'Team members are HIPAA Certified',
    'Strong billing and audit team to ensure correct billing and avoid billing errors',
    'Help clients maximize practice revenues, reduce expenses, increase collections, and improve overall efficiency'
  ];

  return (
    <main className="outsource-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item active">Outsource Medical Billing</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="outsource-hero">
        <div className="container">
          <div className="outsource-hero-content">
            <h1 className="outsource-hero-title">
              Outsource Medical Billing Services <span className="highlight">starting at Just 2.49%</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="outsource-main">
        <div className="container">
          <div className="outsource-grid">
            {/* Left Column - Benefits */}
            <div className="outsource-benefits">
              <h2 className="benefits-title">Benefits Of Outsourcing Your Billing To Us</h2>
              
              <div className="benefits-guarantee">
                <h3 className="guarantee-title">We guarantee:</h3>
                <ul className="benefits-list">
                  {benefits.map((benefit, index) => (
                    <li key={index}>
                      <span className="check-mark">✅</span>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <ul className="features-list">
                {features.map((feature, index) => (
                  <li key={index}>
                    <span className="check-mark">✅</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column - Form */}
            <div className="outsource-form-wrapper">
              <h3 className="form-title">Get a Free Consultation</h3>
              {submitStatus.message && (
                <div className={`status-message ${submitStatus.type}`}>
                  {submitStatus.message}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="text" name="practiceName" placeholder="Practice Name" value={formData.practiceName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <select name="specialty" value={formData.specialty} onChange={handleChange} required>
                    <option value="">Select Specialty</option>
                    {specialties.map(spec => <option key={spec} value={spec}>{spec}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <textarea name="message" rows="3" placeholder="Tell us about your practice..." value={formData.message} onChange={handleChange}></textarea>
                </div>
                <button type="submit" className="submit-btn-outsource" disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Get Started →'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Badges Section */}
      <section className="trust-badges-outsource">
        <div className="container">
          <div className="badges-wrapper-outsource">
            {/* <div className="badge-item-outsource">
              <div className="badge-rating-large">4.8</div>
              <div className="badge-stars">⭐⭐⭐⭐⭐</div>
              <div className="badge-label">Google Rating</div>
            </div> */}
            <div className="badge-item-outsource">
              <div className="badge-icon-large">✓</div>
              <div className="badge-label">ACCREDITED BUSINESS</div>
            </div>
            <div className="badge-item-outsource">
              <div className="badge-icon-large">🔒</div>
              <div className="badge-label">HIPAA COMPLIANT</div>
            </div>
            <div className="badge-item-outsource">
              <div className="badge-icon-large">⚖️</div>
              <div className="badge-label">DMCA PROTECTED</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="outsource-cta">
        <div className="container">
          <div className="cta-content-outsource">
            <h2>Ready to Outsource Your Medical Billing?</h2>
            <p>Join hundreds of satisfied practices that have increased revenue by 15-30% with our services.</p>
            <button className="cta-outsource-btn" onClick={() => document.querySelector('.outsource-form-wrapper').scrollIntoView({ behavior: 'smooth' })}>
              Schedule a Free Consultation →
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default OutsourceMedicalBilling;